import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Snackbar } from '@material-ui/core';
import { Check, CheckCreationModal } from './CheckCreationModal';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 16
  }
}));

interface Props {
  onCheckAdded: (newCheck: Check) => void;
}

const CreateCheck = (props: Props) => {
  const classes = useStyles();
  const [toggleCheckCreation, setToggleCheckCreation] = useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);

  const onRequestClose = (newCheck: Check) => {
    if (newCheck)
      props.onCheckAdded(newCheck);
    setToggleCheckCreation(false);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  return (
    <div className={classes.container}>
      <Button variant="contained" onClick={() => setToggleCheckCreation(true)}>Enregistrer un nouveau chèque</Button>
      {toggleCheckCreation &&
        <CheckCreationModal
          open={toggleCheckCreation}
          onClose={() => setToggleCheckCreation(false)}
          onRequestClose={onRequestClose}
          onSubscriptionUpdate={() => setOpenSnackBar(true)}
        />
      }
      <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Abonnement mis à jour !
        </Alert>
      </Snackbar>
    </div>
  );
}

export default CreateCheck;